import React, { useEffect, useRef, useState } from 'react';
import { Input, Button, Space, Divider, Row, Col, Modal, Tag, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import AddSvg from '../../assets/images/AddSvg';
import TrashSvg from '../../assets/images/TrashSvg';
import CategorySvg from '../../assets/images/CategorySvg';
import { NEWS_CATEGORY_URL, TECHNICALS_CATEGORY_URL } from '../../api/URLs';
import { deleteDataRequest, getDataRequest, postDataRequest } from '../../api/serviceMethods';
import MessageConfirmModal from '../../components/messageModal/MessageConfirmModal';
import TextAreaComponent from '../../components/input/TextAreaComponent';
import TextArea from 'antd/es/input/TextArea';

const TechnicalCategoryModal = ({ }) => {
    const messageModalRef = useRef('')
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false)
    const { t } = useTranslation();
    const [newTag, setNewTag] = useState("");
    const [description, setDescription] = useState("");
    const [tags, setTags] = useState([
        // {
        //     name: ""
        // }
    ]);
    const [tableParams, setTableParams] = useState({
        pagination: {
            // current: 1,
            // pageSize: 10,
            // total: 0,
        },
    });
    
    const getDataRequestAll = async (value) => {
        setLoading(true)
        await getDataRequest(`${TECHNICALS_CATEGORY_URL}`, {
            pageNo: tableParams.pagination.current,
            pageSize: tableParams.pagination.pageSize,
            //   keyword: value ? value.trim() : '',
            //   createdAt: dates ? formatDateSecondary(dates) : '',
        }).then((res) => {
            if (res.status === 200) {
                let datas = res?.data ? res?.data.map((it, i) => ({
                    ...it,
                    name: it.name || "",
                })) : []
                setTags(datas);
            }
            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    total: res.total,
                },
            });
            setLoading(false);
        }).catch((err) => {
            setLoading(false)
            console.log("Error", err)
        });
    }
    useEffect(() => {
        // modalOpen && getDataRequestAll()
        getDataRequestAll()
    }, [modalOpen])

    const handleCreate  = async(name, descrition) => {
        try {
          setLoading(true);
          await postDataRequest(`${TECHNICALS_CATEGORY_URL}`, { name: name, description: description })
            .then((res) => {
              if (res.status === 200) {
                setNewTag("");
                setDescription("")
                messageModalRef.current.showSuccessConfirmsAutoClose(res && res.message, () => { }, "", true);
                getDataRequestAll('');
                setTimeout(() => {
                  setLoading(false);
                }, 2000);
              } else {
                messageModalRef.current.showWarningConfirmsAutoClose(res && res.message, () => { }, "", true);
              }
              setLoading(false);
            })
            .catch((err) => {
              setLoading(false);
              messageModalRef.current.showWarningConfirmsAutoClose(err && err.response && err.response.data && err.response.data.message || `Server Error!`, () => { }, "", true);
            });
        } catch (error) {
          setLoading(false)
          messageModalRef.current.showWarningConfirmsAutoClose(`Server Error!`, () => { }, "", true);
        }
      }
    
    const handleAddTag = () => {
        if (newTag.trim() !== "") {
            let filterData = tags.filter(it => it.name === newTag.trim())
            if(filterData.length > 0) {
                messageModalRef.current.showWarningConfirmsAutoClose(t('The category has exited!'), () => { }, "", true);
                return false
            }
            handleCreate(newTag.trim() )
            // setTags([...tags, { name: newTag }]);
            // setNewTag("");
        }
    };

    const handleDeleteTag = (tag, i) => {
        if (tag._id) {
            messageModalRef.current.showWarningConfirm(t('Are you sure you want to delete this category?'), async () => {
                setLoading(true)
                await deleteDataRequest(`${TECHNICALS_CATEGORY_URL} `, { name: tag.name }).then((res) => {
                    messageModalRef.current.showSuccessConfirmsAutoClose(res && res.message, () => { }, "", true);
                    getDataRequestAll('');
                    setLoading(false)
                }).catch((err) => {
                    messageModalRef.current.showWarningConfirmsAutoClose(`Server Error!`, () => { }, "", true);
                    setLoading(false)
                });
            }, "", true);
        } else {
            setTags(tags.filter((t) => t !== tag));
        }
    };

    return (
        <>
            <Button
                // type="text"
                className=''
                type="text"
                onClick={() => setModalOpen(true)}
                style={{
                    fontSize: '16px',
                    marginRight: "1rem",
                    color: "#e72158",
                    border: "1px solid #e72158"
                }}
            >
                {t('Category Management')}
            </Button>
            <Modal
                title={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <CategorySvg />
                        <span style={{ marginLeft: "10px" }}>{t('Category Management')}</span>
                    </div>
                }
                centered
                width={700}
                open={modalOpen}
                className='custom-modal'
                onOk={() => setModalOpen(false)}
                onCancel={() => {
                    setModalOpen(false)
                    setTags([])
                }}
                cancelButtonProps={{ style: { display: 'none' } }}
                okButtonProps={{ style: { display: 'none' } }}
            >
                <Spin spinning={loading}>
                <hr />
                <div style={{ padding: "20px 60px", marginBottom: "10px" }}>
                    <Row className='d-flex align-items-center'>
                        <Col md={6}>{t("New Category")} :</Col>
                        <Col md={16}>
                            <Input
                                size='large'
                                style={{ marginRight: "8px" }}
                                placeholder=""
                                value={newTag}
                                onChange={(e) => setNewTag(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleAddTag(); // Call the function when Enter is pressed
                                    }
                                }}
                            />
                        </Col>
                        <Col md={2}>
                            <Button
                                style={{
                                    backgroundColor: "#F8E2E8",
                                    border: "none",
                                    color: "#E50A47",
                                    height: "26px",
                                    width: "26px",
                                    marginLeft: "10px",
                                    borderRadius: "50%"
                                }}
                                icon={<AddSvg />}
                                onClick={handleAddTag}
                            /></Col>
                    </Row>
                    <Row align="middle" className='mt-3'>
                        <Col md={6} span={5}>{t('Description')}:</Col>
                        <Col md={16} className="text-capitalize">
                            <TextArea  value={description} onChange={(e) => setDescription(e.target.value)} />
                        </Col>
                    </Row>
                </div>
                <div style={{ borderBottom: "1px dashed #ddd", marginBottom: "16px" }}></div>
                <div className='d-flex align-items-baseline' style={{ padding: "10px 60px", }}>
                    <Col md={6} >{t("Category")} :</Col>
                    <div style={{ marginTop: "8px", display: "flex", flexWrap: "wrap", gap: "8px" }}>
                            {tags.map((tag, index) => (
                                <div
                                    key={tag._id || index}
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "flex-start",
                                        padding: "16px",
                                        marginBottom: "12px",
                                        background: "#fdecf1",
                                        border: "1px solid #f8d7df",
                                        borderRadius: "12px",
                                    }}
                                >
                                    <div style={{ flex: 1 }}>
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                color: "#E50A47",
                                                fontSize: "16px",
                                                fontWeight: 600,
                                                marginBottom: "8px",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    width: "8px",
                                                    height: "8px",
                                                    borderRadius: "50%",
                                                    backgroundColor: "#E50A47",
                                                }}
                                            />

                                            {tag.name}
                                        </div>

                                        <div
                                            style={{
                                                color: "#667085",
                                                fontSize: "14px",
                                                lineHeight: "20px",
                                            }}
                                        >
                                            {tag.description}
                                        </div>
                                    </div>

                                    <div
                                        style={{
                                            cursor: "pointer",
                                            marginLeft: "12px",
                                        }}
                                        onClick={() => handleDeleteTag(tag)}
                                    >
                                        <TrashSvg width={20} height={20} opacity={1}/>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
                <div className='d-flex justify-content-center mt-3'>
                    <Button
                        disabled={tags.length > 0 ? false : true}
                        style={{
                            backgroundColor: "#E50A47",
                            border: "none",
                            color: "White",
                            height: "45px",
                            width: "230px",
                            margin: "auto",
                            borderRadius: "10px",
                            fontSize: "16px",
                            fontWeight: 500,
                            opacity: tags.length > 0 ? 1 : 0.5
                        }}
                        onClick={() => setModalOpen(false)}
                    >
                        {t("Confirm Submit")}
                    </Button>
                </div>
                </Spin>
            </Modal>
            <MessageConfirmModal textCentered ref={messageModalRef} />
        </>
    );
};

export default TechnicalCategoryModal;
